module.exports = __webpack_public_path__ + "static/media/nu.433deb3d.svg";